/** Canonical morph class strings (must match Laravel App\Models\*). */
export const USERABLE_JOB_SEEKER = "App\\Models\\JobSeeker";
export const USERABLE_EMPLOYER = "App\\Models\\Employer";

/**
 * Auth0 / sessionStorage round-trips can double-escape backslashes
 * (e.g. App\\\\Models\\\\JobSeeker). Collapse to a single backslash segment.
 */
export function normalizeUserableType(raw) {
  let s = String(raw ?? "").trim();
  while (s.includes("\\\\")) {
    s = s.replace(/\\\\/g, "\\");
  }
  if (s === USERABLE_EMPLOYER) {
    return USERABLE_EMPLOYER;
  }
  if (s === USERABLE_JOB_SEEKER) {
    return USERABLE_JOB_SEEKER;
  }
  if (/Employer/i.test(s)) {
    return USERABLE_EMPLOYER;
  }
  return USERABLE_JOB_SEEKER;
}
